'use client';

import * as React from 'react';
import { motion } from 'motion/react';
import { cn } from '@/lib/utils';

export type FilterButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
  count?: number;
  children: React.ReactNode;
};

export function FilterButton({
  active = false,
  count,
  children,
  className,
  ...props
}: FilterButtonProps) {
  return (
    <motion.button
      whileHover={{ scale: 1.05, y: -2 }}
      whileTap={{ scale: 0.95 }}
      className={cn(
        'flex items-center space-x-2 px-4 py-2 rounded-lg border transition-all duration-200 font-montserrat whitespace-nowrap relative overflow-hidden',
        active
          ? 'bg-gradient-to-r from-[#6a0dad] to-[#8a2be2] text-white border-[#8a2be2] shadow-lg shadow-[#8a2be2]/30'
          : 'bg-white/10 dark:bg-white/5 text-white/80 dark:text-white/70 border-white/20 dark:border-white/10 hover:bg-white/20 dark:hover:bg-white/10',
        className
      )}
      {...props}
    >
      {active && (
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
          initial={{ x: '-100%' }}
          animate={{ x: '100%' }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
        />
      )}
      <span className="relative z-10 flex items-center gap-2">
        {children}
      </span>
      {count !== undefined && (
        <span
          className={cn(
            'px-2 py-1 rounded-full text-xs relative z-10',
            active
              ? 'bg-white/20 text-white'
              : 'bg-gray-200 dark:bg-white/20 text-gray-700 dark:text-white'
          )}
        >
          {count}
        </span>
      )}
    </motion.button>
  );
}

